import React from 'react';
import Link from 'next/link';
import { CastAndCrewFragment } from 'app/graphql/__generated__/types/contento';
import {
    CastAndCrewHeading,
    ListHeading,
    Name,
    StyledCastAndCrew,
    CastAndCrewLists,
    CastAndCrewSection,
    CastAndCrewLink,
    CastAndCrewUl,
} from './CastAndCrew.styles';

export type CastAndCrewProps = {
    castAndCrew?: CastAndCrewFragment[];
};

const CastAndCrew = ({ castAndCrew }: CastAndCrewProps) => {
    if (!castAndCrew || castAndCrew.length < 1) {
        return null;
    }

    return (
        <StyledCastAndCrew>
            <CastAndCrewHeading>Medverkande och kreatörer</CastAndCrewHeading>
            <CastAndCrewLists>
                {castAndCrew.map((castCrew) => (
                    <CastAndCrewSection key={`cast-crew-section-${castCrew.name}`}>
                        <ListHeading>{castCrew.name}</ListHeading>
                        <CastAndCrewUl>
                            {castCrew.people.map((person) => (
                                <Name as="li" key={`cast-crew-${person.name}`}>
                                    {person.numberOfParticipations > 1 ? (
                                        <Link passHref href={`/sok?q=${person.name}`}>
                                            <CastAndCrewLink>{person.name}</CastAndCrewLink>
                                        </Link>
                                    ) : (
                                        <span>{person.name}</span>
                                    )}
                                </Name>
                            ))}
                        </CastAndCrewUl>
                    </CastAndCrewSection>
                ))}
            </CastAndCrewLists>
        </StyledCastAndCrew>
    );
};

export default CastAndCrew;
